import {Component, Input, OnInit} from '@angular/core';
import {StudentModel} from '../../../../models/authentication/student.model';
import {TranslateService} from '@ngx-translate/core';
import {SkillGroupBaseModel} from '../../../../models/edu-admin/skillGroupBase.model';
import {SkillGroupStructureModel} from '../../../../models/student/skillGroupStatusModel';
import {EVOSegmentedControlItem} from '../../../../shared/reusable-controls/evo-segmented-control/evo-segmented-control.component';
import {PlacementTestModel} from '../../../../models/edu-admin/placement-test.model';
import {PlacementTestGroupAttempt} from '../../../../models/student/placement-test-attempt.model';

@Component({
  selector: 'app-group-dash-skills-overview',
  templateUrl: './group-dash-skills-overview.component.html',
  styleUrls: ['./group-dash-skills-overview.component.css']
})
export class GroupDashSkillsOverviewComponent implements OnInit {

  controls: EVOSegmentedControlItem[] = [];
  currentControl: EVOSegmentedControlItem;


    /**
   * Added two types of placement layouts skills
   * or scaffolded
   */
  placementLayout = 'scaffolded';

  @Input() students: StudentModel[] = [];
  @Input() skillGroupsObjective: SkillGroupBaseModel[];
  @Input() skillStatus: SkillGroupStructureModel;
  @Input() skillGroupsPlacement: SkillGroupBaseModel[];
  @Input() placementStatus: SkillGroupStructureModel;
  @Input() attempts: PlacementTestGroupAttempt[];

  @Input() assessmentStructure: PlacementTestModel;

  constructor(public tSv: TranslateService) { }

  ngOnInit() {

    this.controls = [
      new EVOSegmentedControlItem('placementTest', 'reusable.placementTest'),
      new EVOSegmentedControlItem('overview', 'reusable.overview')
    ];
    this.currentControl = this.controls[1];

  }

  getContainerWidth(): string {

    return (this.students.length * 62).toString() + 'px';

  }

  getSkillGroups(): SkillGroupBaseModel[] {

    if (this.skillGroupsObjective && this.currentControl.key === 'overview') {
      return this.skillGroupsObjective;
    } else if (this.skillGroupsPlacement && this.currentControl.key === 'placementTest') {
      return this.skillGroupsPlacement;
    }

    return [];
  }

  numStudentsCompletedPlacementTest(): number {

    let numCompleted = 0;
    if (this.attempts) {
      numCompleted = this.attempts.length;
    }

    return numCompleted;
  }

  numStudents(): number {

    if (this.students) {
      return this.students.length;
    }

    return 0;

  }

  studentCompletedRatioString(): string {

    return `${this.numStudentsCompletedPlacementTest()} / ${this.numStudents()}`;

  }

  studentsNotCompletedRatioString(): string {

    const notCompleted = this.numStudents() - this.numStudentsCompletedPlacementTest();

    return `${notCompleted} / ${this.numStudents()}`;

  }

  studentsAvgPlacementTestResult(): number {

    if (!this.attempts || this.attempts.length === 0) {
      return 0;
    }

    let avgResult = 0;

    for (const attempts of this.attempts) {
      avgResult += attempts.placementTestAttempt.result();
    }

    return avgResult / this.attempts.length;

  }

  studentsAvgPlacementTestResultString(decimals: number = 0): string {

    return this.studentsAvgPlacementTestResult().toFixed(decimals);
  }

  studentsAvgResultString(): string {

    return `${this.studentsAvgPlacementTestResultString(2)} / ${this.assessmentStructure.getNumQuestionsInTest()}`;
  }

  // tslint:disable-next-line:max-line-length
  getColorsForStudentSkillGroupMastery(studentId: string, skillGroupId: string): { 'background-color': string, 'border-width': string, 'border-style': string, 'border-color': string } {

    if ((this.skillStatus && this.currentControl.key === 'overview') ||
      (this.placementStatus && this.currentControl.key === 'placementTest')) {

      let value = null;
      if (this.currentControl.key === 'overview') {

        value = this.skillStatus.masteryForStudentSkillGroupStatus(studentId, skillGroupId);

      } else if (this.currentControl.key === 'placementTest') {

        value = this.placementStatus.masteryForStudentSkillGroupStatus(studentId, skillGroupId);

      }

      if (value === -2) {
        // Indicates the student is struggling with a question/skill in the skill group
        return {
          'background-color': 'rgba(215, 33, 33, 0.3)',
          'border-width': '1px',
          'border-style': 'solid',
          'border-color': 'rgba(215, 33, 33, 1.0)'
        };

      } else if (value >= 0 && value < 0.5) {

        return {
          'background-color': 'rgba(255, 203, 5, 0.3)',
          'border-width': '1px',
          'border-style': 'solid',
          'border-color': 'rgba(255, 203, 5, 1.0)'
        };

      } else if (value >= 0.5 && value < 0.8) {


        return {
          'background-color': 'rgba(155, 89, 182, 0.3)',
          'border-width': '1px',
          'border-style': 'solid',
          'border-color': 'rgba(155, 89, 182, 1.0)'
        };


      } else if (value >= 0.8 && value < 1.0) {

        return {
          'background-color': 'rgba(121, 197, 112, 0.3)',
          'border-width': '1px',
          'border-style': 'solid',
          'border-color': 'rgba(121, 197, 112, 1.0)'
        };

      } else if (value >= 1.0) {

        return {
          'background-color': 'rgba(0, 156, 204, 0.3)',
          'border-width': '1px',
          'border-style': 'solid',
          'border-color': 'rgba(0, 156, 204, 1.0)'
        };

      }

    }

    // Default gray color
    return {
      'background-color': 'rgba(216, 216, 216, 0.3)',
      'border-width': '1px',
      'border-style': 'solid',
      'border-color': 'rgba(216, 216, 216, 1)'
    };

  }

}
